import { SelectItem } from "@fronterahealth/frontera-ui-components";

import { MoveGoalBankGoalInput, useMoveGoalBankGoalMutation } from "@api/graphql/types-and-hooks";
import { FolderManagementAction } from "@components/GoalsBank/constants";
import { FolderManagementDialog } from "@components/GoalsBank/dialogs/FolderManagementDialog";
import { findFolderSelection } from "@components/GoalsBank/utils";
import { FormContainer } from "@components/forms/FormLayout";
import { useFormUtils } from "@components/forms/useFormUtils";
import { notifySuccess } from "@components/notifications/notifications";

interface MoveShortTermGoalToFolderProps {
  currentFolderId: string;
  goalBankShortTermId?: string;
  onCloseClick: () => void;
  open: boolean;
  foldersSelection: SelectItem[];
  refetch: () => void;
}

export const MoveShortTermGoalToFolder: React.FC<MoveShortTermGoalToFolderProps> = ({
  currentFolderId,
  goalBankShortTermId,
  onCloseClick,
  open,
  foldersSelection,
  refetch,
}) => {
  const moveGoalBankGoal = useMoveGoalBankGoalMutation({});
  const { formState, RegisteredFormSelected, reset, onSubmit, watch } = useFormUtils<MoveGoalBankGoalInput>({
    mutationFn: async (params) => {
      if (params.newFolderId && goalBankShortTermId)
        moveGoalBankGoal.mutateAsync(
          {
            input: {
              goalBankShortTermId,
              currentFolderId,
              newFolderId: params.newFolderId,
            },
          },
          {
            onSuccess: async () => {
              await refetch();
              notifySuccess(`Successfully Moved Short Term Goal`);
              reset();
              await onCloseClick();
            },
            onError: async (error: unknown) => {
              console.error(`Error when moving short term goal `, error);
            },
          },
        );
    },
  });

  const newFolderIdWatch = watch("newFolderId");

  const placeholderText = () => {
    const selection = findFolderSelection(newFolderIdWatch ?? currentFolderId, foldersSelection);
    return selection ? selection.primary : "Select a folder";
  };

  return (
    <FolderManagementDialog
      action={FolderManagementAction.MOVE}
      open={open}
      onCancelClick={onCloseClick}
      onSaveClick={onSubmit}
    >
      <FormContainer onSubmit={onSubmit}>
        <RegisteredFormSelected
          formKey="newFolderId"
          required
          formState={formState}
          items={foldersSelection}
          title={"Select Folder"}
          placeholderText={placeholderText()}
        />
      </FormContainer>
    </FolderManagementDialog>
  );
};
